import { fetchAsObservable } from "fetcher!sofe";

export function getBannerNotification(bannerId) {
  return fetchAsObservable(`/wg/banner/${bannerId}`);
}
